import { Component, signal, Inject, inject } from '@angular/core';
import { ActivatedRoute, RouterOutlet } from '@angular/router';
import { CommonModule } from '@angular/common';
import { HeaderComponent } from "./master/header.component/header.component";
import { SidebarComponent } from './master/sidebar.component/sidebar.component';
import { FooterComponent } from "./master/footer.component/footer.component";
import { ModalComponent } from './shared/modal.component/modal.component';
import { AlertComponent } from './shared/alert.component/alert.component';
//import { LockComponent } from './shared/lock.component/lock.component';

import { GsapService } from './core/services/gsap.service';
import { AlertService } from './core/services/alert.service';
import { ModalService } from './core/services/modal.service';
import { SignalService } from './core/services/signal.service';
import { eClick } from './core/services/entities';
import { HaylieService } from './core/services/haylie.service';
import { MasterService } from './core/services/master.service';
//import { TranslateService } from '@ngx-translate/core';

@Component({
  selector: 'app-root',
  imports: [RouterOutlet, HeaderComponent, SidebarComponent, FooterComponent, CommonModule, ModalComponent, AlertComponent],
  templateUrl: './app.html',
  styleUrl: './app.scss'
})
export class App {
  protected readonly title = signal('boss-webapps');

  readonly s_alert = inject(AlertService).alert;
  readonly s_modal = inject(ModalService).modal;
  readonly s_lock = inject(SignalService).lock;

  private _svc_master = inject(MasterService);

  constructor(private gsap:GsapService, 
        private _svcalert: AlertService, 
        private _svcmodal: ModalService,
        private _svcsignal: SignalService,
        private _svchaylie: HaylieService 
      //private active_route: ActivatedRoute  
    ) {
    this.s_modal = this._svcmodal.modal;
    this.s_alert = this._svcalert.alert;
    this.s_lock = this._svcsignal.lock;
    
    //_svctranslate.setDefaultLang('en');
  }

  ngOnInit(){

    const allowedRoutes = [
      'joinus', 'arena', 'track', 'modalities', 'agenda', 'packages', 'home'
    ];

    if (!allowedRoutes.includes(window.location.pathname.toLowerCase().replace("/","")))
      this._svc_master.navigate("joinus");


    // }
    // 

    // if (!localStorage.getItem('app-state')) {
    //   localStorage.getItem('app-state')
    // }


    // const clang = localStorage.getItem('lang') || 'pt';
    // this._svctranslate.use(clang); 
  }
  ngAfterViewInit() { 
    this.gsap.init_setup();
    this.gsap.anima_full();

    this.gsap.anima_trg("outsider", "init");
  }
  /*** *tmp **/
  goHaylie(p_param:string): void{

    switch (p_param) {
      case "regclick":

        var click = new eClick();

        this._svchaylie.send_click(click); 
        break;
    }

  }

}
